import { Observable } from 'rxjs'
import {} from '@angular/common/http'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { EnrollmentElectionType } from '../models/enrollment-election-type'
import { EnrollmentDetail } from '../models/en-details'
import { EnrollmentGateway } from './enrollment-gateway'
import { PlanList } from '../models/plan-list'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { EnrollmentData } from '../models/enrollment-data'
import { SubmitEnrollmentDataResponse } from '../models/submit-enrollment-data-response'
import { BeneficiarySoaDetail } from '../models/view-soa-model'
import { SearchInsertModel } from '../models/search-soa-model'
import { SaveEmailModel } from '../models/saveEmailModel'
// import { SavePharmacyEmailModel } from '../models/save-pharmacy-email-model'
import { EnrollmentPageContent } from '../models/enrollment-page-content-model'
import { SendEmailModel } from '../models/SendEmailModel'
import { SetEnrollmentDataPdf } from '../models/set-enrollment-data-pdf'
import { EnrollmentField, EnrollmentFieldCodes, EnrollmentFieldEapp } from '../models/enrollment-field'
import { EnrollmentSettingModel } from '../models/EnrollmentSettingModel'
import { ElectionPeriods } from '../models/election-periods'
import { EappUpdateStatus } from '../models/eapp-status-model'
import { ValidAgent } from '../models/valid-agent'
import { GetEnrollmentDataModel } from '../models/getEnrollmentDataModel'
import { GroupPlanFilterData } from '../models/GroupPlanFilterData'

import { ExportSOAModel } from '../../electronic-soa/models/export-soa-model'
import { stcobModel } from '../models/stcob-model'
import { ExportHistoryModel } from '../models/export-history-model'
import { OrgFeatureSettingValue } from '../../bak-questions/models/bakquestions'
import { PreEnrollmentCallLogDetails } from '../models/PreEnrollmentCallLogDetails'
import { DispositionLookUP } from '../../call-start/models/disposition-lookup'
import { CallLogLookUp } from '../../call-start/models/call-log-lookup'
import { PortalGlobals } from '../../../app/portalglobals'
import { IPadHistory } from '../models/ipadhistory-model'
import { IPadPDF } from '../models/ipadhistory-model'
import { HttpParams, HttpHeaders } from '@angular/common/http'

import { EnrollmentHeader } from '../models/EnrollmentHeader'
import { GetEnrollmentRequest } from '../models/GetEnrollmentDataRequest'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../models/get-enrollment-data-response'

import { CurrentUser } from '../../../app/common/models/current-user'
import { PhonePage3Data } from '../models/phone-page3-data'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import * as moment from 'moment'
import { stream } from 'xlsx/types'
import { ElectionModel } from '../models/election-model'
import { ValidatedSelectOptionModel as ReasonCode } from '../../validations/validated-dropdown.component'
import { environment } from '../../../environments/environment'
import { EthnicityData } from '../models/ethnicity-data'
import { RaceData } from '../models/race-data'
import { GenderPref } from '../models/gender-pref'
import { RelationshipToEnrollee } from '../models/relationshipToEnrollee'

@Injectable()
export class NetworkEnrollementGateway extends EnrollmentGateway {
    private _enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    private _enrollmentDataModel: GetEnrollmentDataModel = new GetEnrollmentDataModel()
    private _generatePdfModel: SetEnrollmentDataPdf = new SetEnrollmentDataPdf()
    private _getEnrollmentRequest: GetEnrollmentRequest = new GetEnrollmentRequest()
    private _getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()

    public _backClicked: boolean
    private _preEnrollmentCallLogDetails: PreEnrollmentCallLogDetails
    public _currentUser: CurrentUser
    constructor(private http: HttpClient, private portalGlobal: PortalGlobals) {
        super()
    }

    getGenderData(genderPref: string): Observable<GenderPref[]> {
        return this.http.get<GenderPref[]>(`../api/enrollment/getGenderPref/${genderPref}`)
    }

    getRelationshipToEnrolleeData(): Observable<RelationshipToEnrollee[]> {
        return this.http.get<RelationshipToEnrollee[]>(`../api/enrollment/getRelationshipToEnrolleeData`)
    }

    getRaceData(): Observable<RaceData[]> {
        return this.http.get<RaceData[]>(`../api/enrollment/getRaceData`)
    }
    getEthnicityData(): Observable<EthnicityData[]> {
        return this.http.get<EthnicityData[]>(`../api/enrollment/getEthnicityData`)
    }

    getEnrollmentElectionTypes(orgID: string, planYear: string): Observable<EnrollmentElectionType[]> {
        return this.http.get<EnrollmentElectionType[]>(`../api/EnrollmentElectionTypesByOrgID/${orgID}/${planYear}`)
    }

    getElectionDetails(confNumber: string): Observable<EnrollmentElectionType[]> {
        return this.http.get<EnrollmentElectionType[]>(`../api/GetElectionDetails/${confNumber}`)
    }

    getPlanList(orgId: number, planyear: string): Observable<PlanList[]> {
        let getURL = '../api/enrollment/GetPlanList/' + orgId + '/' + planyear
        return this.http.get<PlanList[]>(getURL)
    }

    getEnrollmentDataByKey(enrollmentKey: string): Observable<GetEnrollmentDataResponse> {
        this._getEnrollmentRequest.EnrollmentKey = enrollmentKey
        return this.http.post<GetEnrollmentDataResponse>('../api/enrollment/GetEnrollmentFilled', JSON.stringify(this._getEnrollmentRequest))
    }

    getEnrollmentViewModelByKey(model: GetEnrollmentDataResponse): EnrollmentViewModel {
        // Get Gender Data..
        var gendPref = 'ALL'
        var genderPref: GenderPref[] = [] as GenderPref[]
        var currentGender: GenderPref[] = [] as GenderPref[]
        var repYourSelf: GenderPref[] = [] as GenderPref[]
        this.getGenderData(gendPref).subscribe((gendPrefData: GenderPref[]) => {
            genderPref = gendPrefData

            if (genderPref !== undefined && genderPref !== null) {
                genderPref.forEach((element, index) => {
                    if (element.GenderPrefListCode.toUpperCase() == 'CURRENTGENDER') {
                        currentGender.push(element)
                    } else if (element.GenderPrefListCode.toUpperCase() == 'GENDERPRONOUN') {
                        repYourSelf.push(element)
                    }
                })
            }

            for (let i = 0; i < model.Data[0].EnrollmentFields.length; i++) {
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ACCHOLDERNAME) {
                    this._enrollmentViewModel.ACCHOLDERNAME = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ELECTION) {
                    this._enrollmentViewModel.ELECTION = model.Data[0].EnrollmentFields[i].FieldValue
                    if (this._enrollmentViewModel.ELECTION !== undefined) {
                    }
                    //this.periodSelected = model.Data[0].EnrollmentFields[i].FieldValue
                }
                //delete
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.RELCD) {
                    this._enrollmentViewModel.RELCD = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AGENTFN) {
                    this._enrollmentViewModel.AGENTFN = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AGENTLN) {
                    this._enrollmentViewModel.AGENTLN = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.PLANTYPE) {
                    this._enrollmentViewModel.PLANTYPE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPDT) {
                    this._enrollmentViewModel.APPDT = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.EFFDT) {
                    this._enrollmentViewModel.EFFDT = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPFN) {
                    this._enrollmentViewModel.APPFN = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPLN) {
                    this._enrollmentViewModel.APPLN = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.SUFFIX) {
                    this._enrollmentViewModel.SUFFIX = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPMI) {
                    this._enrollmentViewModel.APPMI = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.TITLE) {
                    this._enrollmentViewModel.TITLE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.HICN) {
                    this._enrollmentViewModel.HICN = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.MEDA) {
                    if (model.Data[0].EnrollmentFields[i].FieldValue !== undefined && model.Data[0].EnrollmentFields[i].FieldValue !== '') {
                        this._enrollmentViewModel.MEDA = model.Data[0].EnrollmentFields[i].FieldValue
                    } else {
                        this._enrollmentViewModel.MEDA = null
                    }
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.MEDB) {
                    if (model.Data[0].EnrollmentFields[i].FieldValue !== undefined && model.Data[0].EnrollmentFields[i].FieldValue !== '') {
                        this._enrollmentViewModel.MEDB = model.Data[0].EnrollmentFields[i].FieldValue
                    } else {
                        this._enrollmentViewModel.MEDB = null
                    }
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPDOB) {
                    this._enrollmentViewModel.APPDOB = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPPHONE) {
                    this._enrollmentViewModel.APPPHONE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPGEN) {
                    if (model.Data[0].EnrollmentFields[i].FieldValue === 'M') {
                        this._enrollmentViewModel.APPGEN = 'M'
                    } else {
                        this._enrollmentViewModel.APPGEN = 'F'
                    }
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.CELLPHONE) {
                    this._enrollmentViewModel.CELLPHONE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPEMAIL) {
                    this._enrollmentViewModel.APPEMAIL = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPADD1) {
                    this._enrollmentViewModel.APPADD1 = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPADD2) {
                    this._enrollmentViewModel.APPADD2 = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.POVERIND) {
                    this._enrollmentViewModel.POVERIND = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPCITY) {
                    this._enrollmentViewModel.APPCITY = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPZIP) {
                    this._enrollmentViewModel.APPZIP = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPST) {
                    this._enrollmentViewModel.APPST = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.LTCFACILITY) {
                    this._enrollmentViewModel.LTCFACILITY = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.LTCPHONE) {
                    this._enrollmentViewModel.LTCPHONE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.NOTES) {
                    this._enrollmentViewModel.NOTES = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.SEPREASONCD) {
                    this._enrollmentViewModel.SEPREASONCD = Number(model.Data[0].EnrollmentFields[i].FieldValue)
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ELECTION) {
                    this._enrollmentViewModel.ELECTION = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.MAILADD1) {
                    this._enrollmentViewModel.MAILADD1 = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.MAILADD2) {
                    this._enrollmentViewModel.MAILADD2 = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.MAILCITY) {
                    this._enrollmentViewModel.MAILCITY = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.MAILST) {
                    this._enrollmentViewModel.MAILST = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.MAILZIP) {
                    this._enrollmentViewModel.MAILZIP = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.PWO) {
                    this._enrollmentViewModel.PWO = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.PLANYEAR) {
                    this._enrollmentViewModel.PLANYEAR = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.LANG) {
                    this._enrollmentViewModel.LANG = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.OTHCVRG) {
                    this._enrollmentViewModel.OTHCVRG = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.LANGFORMAT) {
                    this._enrollmentViewModel.EOB = model.Data[0].EnrollmentFields[i].FieldValue
                    this._enrollmentViewModel.LANGFORMAT = model.Data[0].EnrollmentFields[i].FieldValue

                    //this.eobOption = this._enrollmentViewModel.EOB
                    //if (this._enrollmentViewModel.EOB.toLowerCase() === 'eeob') {
                    //    this.eobEmail = 'Email Address'
                    //}
                    //else {
                    //    this.eobEmail = 'Email Address (optional)'
                    //}
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ENROLLEEWORKSTATUS) {
                    this._enrollmentViewModel.ENROLLEEWORKSTATUS = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.SPOUSEWORKSTATUS) {
                    this._enrollmentViewModel.SPOUSEWORKSTATUS = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ACCOUNTNB) {
                    this._enrollmentViewModel.ACCOUNTNB = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.OTHCVRGNAME) {
                    this._enrollmentViewModel.OTHCVRGNAME = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AGENTID) {
                    this._enrollmentViewModel.AGENTID = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.OTHCVRGID) {
                    this._enrollmentViewModel.OTHCVRGID = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.OTHCVRGGRP) {
                    this._enrollmentViewModel.OTHCVRGGRP = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.COBBIN) {
                    this._enrollmentViewModel.COBBIN = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.COBPCN) {
                    this._enrollmentViewModel.COBPCN = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.COBEFFDT) {
                    if (model.Data[0].EnrollmentFields[i].FieldValue !== undefined && model.Data[0].EnrollmentFields[i].FieldValue !== '') {
                        this._enrollmentViewModel.COBEFFDT = model.Data[0].EnrollmentFields[i]
                    } else {
                        this._enrollmentViewModel.COBEFFDT = null
                    }
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.COBTERMDT) {
                    if (model.Data[0].EnrollmentFields[i].FieldValue !== undefined && model.Data[0].EnrollmentFields[i].FieldValue !== '') {
                        this._enrollmentViewModel.COBTERMDT = model.Data[0].EnrollmentFields[i]
                    } else {
                        this._enrollmentViewModel.COBTERMDT = null
                    }
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.FININSTNAME) {
                    this._enrollmentViewModel.FININSTNAME = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.EFTTYPE) {
                    this._enrollmentViewModel.EFTTYPE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ROUTINGNB) {
                    this._enrollmentViewModel.ROUTINGNB = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.SEPEFFDT) {
                    if (model.Data[0].EnrollmentFields[i].FieldValue !== undefined && model.Data[0].EnrollmentFields[i].FieldValue !== '') {
                        this._enrollmentViewModel.SEPEFFDT = model.Data[0].EnrollmentFields[i]
                        //this.sepDate = moment(this._enrollmentViewModel.SEPEFFDT)
                    } else {
                        this._enrollmentViewModel.SEPEFFDT = null
                        //this.sepDate = null
                    }
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPIND) {
                    this._enrollmentViewModel.AUTHREPIND = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPNAME) {
                    this._enrollmentViewModel.AUTHREPNAME = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPPHONE) {
                    this._enrollmentViewModel.AUTHREPPHONE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPREL) {
                    this._enrollmentViewModel.AUTHREPREL = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPADD1) {
                    this._enrollmentViewModel.AUTHREPADD1 = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPCITY) {
                    this._enrollmentViewModel.AUTHREPCITY = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPST) {
                    this._enrollmentViewModel.AUTHREPST = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPZIP) {
                    this._enrollmentViewModel.AUTHREPZIP = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPADD2) {
                    this._enrollmentViewModel.AUTHREPADD2 = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPCOPYIND) {
                    this._enrollmentViewModel.AUTHREPCOPYIND = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.SOA) {
                    this._enrollmentViewModel.SOA = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.PLANNAME) {
                    this._enrollmentViewModel.PLANNAME = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.CUID) {
                    this._enrollmentViewModel.CUID = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.DEX) {
                    this._enrollmentViewModel.DEX = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AGENTDEX) {
                    this._enrollmentViewModel.AGENTDEX = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.DATEOFRECEIPT) {
                    this._enrollmentViewModel.DATEOFRECEIPT = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AGENTID) {
                    this._enrollmentViewModel.AGENTID = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ADMINID) {
                    this._enrollmentViewModel.ADMINID = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.EMERIND) {
                    this._enrollmentViewModel.EMERIND = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === 'RBLLONGTERM') {
                    this._enrollmentViewModel.RBLLONGTERM = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.EMERNAME) {
                    this._enrollmentViewModel.EMERNAME = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.EMERPHONE) {
                    this._enrollmentViewModel.EMERPHONE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.EMERREL) {
                    this._enrollmentViewModel.EMERREL = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.APPSIGNEDIND) {
                    this._enrollmentViewModel.APPSIGNEDIND = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.AUTHREPSIGNEDIND) {
                    this._enrollmentViewModel.AUTHREPSIGNEDIND = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === 'AUTHREPEMAIL') {
                    this._enrollmentViewModel.AUTHREPEMAIL = model.Data[0].EnrollmentFields[i].FieldValue
                }

                //Group Fields
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.SECMBRID) {
                    this._enrollmentViewModel.SECMBRID = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.FAMILYID) {
                    this._enrollmentViewModel.FAMILYID = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.PERSONCD) {
                    this._enrollmentViewModel.PERSONCD = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.CAREFAC) {
                    this._enrollmentViewModel.CAREFAC = model.Data[0].EnrollmentFields[i].FieldValue
                }

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.LTCADD1) {
                    this._enrollmentViewModel.LTCADD1 = model.Data[0].EnrollmentFields[i].FieldValue
                }

                //Missing Field

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.CC) {
                    this._enrollmentViewModel.CC = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.UNMTHS) {
                    this._enrollmentViewModel.UNMTHS = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.DISENROLLIND) {
                    this._enrollmentViewModel.DISENROLLIND = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.DISENROLLDATE) {
                    this._enrollmentViewModel.DISENROLLDATE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.DISENROLLNOTICEDT) {
                    this._enrollmentViewModel.DISENROLLNOTICEDT = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.DISENROLLREASONCD) {
                    this._enrollmentViewModel.DISENROLLREASONCD = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.DISENROLLTYPE) {
                    this._enrollmentViewModel.DISENROLLTYPE = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.CHANNELID) {
                    this._enrollmentViewModel.CHANNELID = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.PLANST) {
                    this._enrollmentViewModel.PLANST = model.Data[0].EnrollmentFields[i].FieldValue
                }
                // Gender
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.CURRENTGENDER) {
                    this._enrollmentViewModel.CURRENTGENDER = model.Data[0].EnrollmentFields[i].FieldValue

                    //display currentGender
                    currentGender.forEach((element, index) => {
                        if (
                            element.GenderPrefListCode.toUpperCase() == 'CURRENTGENDER' &&
                            element.DM46Code == Number(this._enrollmentViewModel.CURRENTGENDER)
                        ) {
                            this._enrollmentViewModel.displayCurrentGender = element.GenderPrefListDesc
                        }
                    })
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.CURRENTGENDEROTH) {
                    this._enrollmentViewModel.CURRENTGENDEROTH = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.GENDERNPRONOUN) {
                    this._enrollmentViewModel.GENDERNPRONOUN = model.Data[0].EnrollmentFields[i].FieldValue

                    repYourSelf.forEach((element, index) => {
                        if (this._enrollmentViewModel.GENDERNPRONOUN != undefined && this._enrollmentViewModel.GENDERNPRONOUN != '') {
                            if (
                                element.GenderPrefListCode.toUpperCase() == 'GENDERPRONOUN' &&
                                element.DM46Code == Number(this._enrollmentViewModel.GENDERNPRONOUN)
                            ) {
                                this._enrollmentViewModel.displayGenderProNoun = element.GenderPrefListDesc
                            }
                        }
                    })
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.GENDERNPRONOUNOTH) {
                    this._enrollmentViewModel.GENDERNPRONOUNOTH = model.Data[0].EnrollmentFields[i].FieldValue
                }
                // Help to ENROLLEE
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.INDREPIND) {
                    this._enrollmentViewModel.INDREPIND = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.INDREPNAME) {
                    this._enrollmentViewModel.INDREPNAME = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.RELTOENROLL) {
                    this._enrollmentViewModel.RELTOENROLL = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.NPN) {
                    this._enrollmentViewModel.NPN = model.Data[0].EnrollmentFields[i].FieldValue
                }

                // Race and ETHNICITY

                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.RACE) {
                    this._enrollmentViewModel.Race = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.ETHNICITY) {
                    this._enrollmentViewModel.Ethnicity = model.Data[0].EnrollmentFields[i].FieldValue
                }
                if (model.Data[0].EnrollmentFields[i].FieldCode === EnrollmentFieldCodes.PRIORID) {
                    this._enrollmentViewModel.PRIORID = model.Data[0].EnrollmentFields[i].FieldValue
                }
            }
        })
        return this._enrollmentViewModel
    }

    // submitEnrollment(orgID: number): Observable<EnrollmentElectionType[]> {
    //     return this.http.post<EnrollmentElectionType[]>(`../api/SubmitEnrollment/${orgID}`, JSON.stringify(orgID))
    // }

    // SendEmail(orgID: number): Observable<any> {
    //    return this.http.get<string>(`../api/enrollment/SendEmail/${orgID}`)
    // }

    SendEmail(mailTo: string, clientName: string, refGUID: string, planYear: string): Observable<any> {
        return this.http.get<string>(`../api/enrollment/SendEmail?mailTo=${mailTo}&clientName=${clientName}&refGUID=${refGUID}&planYear=${planYear}`)
    }

    SendAgentEmail(mailTo: string, agentName: string, agentId: number, beneName: string): Observable<any> {
        return this.http.get<string>('../api/enrollment/SendAgentEmail/' + mailTo + '/' + agentName + '/' + agentId + ' / ' + beneName)
    }

    // SendPharmacyEmail(mailTo: string,FirstName:string, LastName: string): Observable<any> {
    //    return this.http.get<string>(`../api/enrollment/SendEmailPharmacy?mailTo=${mailTo}&FirstName=${FirstName}&LastName=${LastName}`)
    // }

    //CheckLicense(state: string): Observable<any>{
    CheckLicense(state: string): Observable<any> {
        return this.http.get<string>(`../api/SendInvitationbyState/${state}`)
    }

    saveEnrollmentEmail(saveEmailModel: SaveEmailModel, planYear: number): Observable<string> {
        return this.http.post<string>('../api/enrollment/SaveEnrollmentEmail/' + planYear, JSON.stringify(saveEmailModel))
    }
    // savePharmacyEmail(saveEmailModel: SavePharmacyEmailModel): Observable<SavePharmacyEmailModel> {
    //    return this.http.post<SavePharmacyEmailModel>('../api/enrollment/SavePharmacyEmail', JSON.stringify(saveEmailModel))
    // }
    SendEmailUser(): Observable<any> {
        return this.http.post<EnrollmentViewModel>(
            '../api/enrollment/SendEmailUser',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }

    setEnrollmentViewModel(value: EnrollmentViewModel) {
        if (value && !this._backClicked) {
            this._enrollmentViewModel = value
        }
        this._backClicked = false
    }

    getEnrollmentViewModel(): EnrollmentViewModel {
        return this._enrollmentViewModel
    }

    GetAdobeConfigurationFlag(): Observable<boolean> {
        let result = this.http.get<boolean>('../api/GetAdobeConfigurationFlag/')
        return result
    }

    //Load Adobe launch code
    LoadAdobeScript() {
        let body = <HTMLDivElement>document.body
        let script = document.createElement('script')
        script.innerHTML = ''
        let result
        this.GetAdobeConfigurationFlag().subscribe((data) => {
            if (data === true) {
                //If prod load prod script else staging one
                script.src = '//assets.adobedtm.com/9e9a5097b655/15c1dead6ee3/launch-51d691afcb33.min.js'
            } else {
                script.src = '//assets.adobedtm.com/9e9a5097b655/15c1dead6ee3/launch-30005d23b515-staging.min.js'
            }
        })

        script.async = true
        script.defer = true
        body.appendChild(script)
    }

    SubmitEnrollmentData(enrollModel: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/SubmitEnrollmentData',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }

    UpdateEnrollmentData(): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/UpdateEnrollmentData',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }

    SubmitElectronicEnrollmentData(): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/SubmitElectronicEnrollment',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }

    UpdateElectronicEnrollmentData(): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/UpdateElectronicEnrollmentData',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }

    searcheAppHistoryData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]> {
        return this.http.post<BeneficiarySoaDetail[]>('../api/enrollment/GetEnrollmentHistory', JSON.stringify(searchsoadetail))
    }

    searchPWeAppHistoryData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]> {
        return this.http.post<BeneficiarySoaDetail[]>('../api/enrollment/GetPWEnrollmentHistory', JSON.stringify(searchsoadetail))
    }

    loadEAppHistoryData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]> {
        console.log('loadsoadata orgID' + searchsoadetail.OrgID)
        return this.http.post<BeneficiarySoaDetail[]>('../api/enrollment/GetEnrollmentHistory', JSON.stringify(searchsoadetail))
    }

    loadPWEAppHistoryData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]> {
        console.log('loadsoadata orgID' + searchsoadetail.OrgID)
        return this.http.post<BeneficiarySoaDetail[]>('../api/enrollment/GetPWEnrollmentHistory', JSON.stringify(searchsoadetail))
    }

    loadBSOADataSync(searchsoadetail: SearchInsertModel): BeneficiarySoaDetail[] {
        var data = JSON.stringify(searchsoadetail)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/enrollment/GetEnrollmentHistory', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    downloadPDF(BeneficiaryPdf: string): Observable<any> {
        return this.http.get<string>('../api/downloadPdf/' + BeneficiaryPdf)
    }

    streamPDF(file: string): Observable<any> {
        return this.http.get('../api/downloadPdfStream/' + file, {
            headers: new HttpHeaders().set('Content-Type', 'application/pdf'),
            responseType: 'blob',
            observe: 'body'
        })
    }

    GetEnrollmentPageContent(ParentName: string, SectionName: string): Observable<EnrollmentPageContent[]> {
        let getURL = '../api/content/GetContactByName/' + ParentName + '/' + SectionName
        return this.http.get<EnrollmentPageContent[]>(getURL)
    }

    isValidAgent(userProfileName: string): Observable<any> {
        let planYear: string = ''

        var planYearStr = sessionStorage.getItem('PLANYEAR')
        if (planYearStr !== undefined) {
            planYear = planYearStr || ''
        }
        let headers = new HttpHeaders()
        headers = headers.set('Content-Type', 'application/json')
        let params = new HttpParams().set('userProfileName', userProfileName).set('planYear', planYear)
        let getURL = '../api/isValidUser/' //+ '/' + userProfileName + '/' + planYear
        //return this.http.get<ValidAgent>(getURL)
        return this.http.get(getURL, { headers: headers, params: params })
    }

    isExternalValid(userProfileName: string): Observable<any> {
        let planYear: string = this.portalGlobal.selectedPlanYear.toString()
        let headers = new HttpHeaders()
        headers = headers.set('Content-Type', 'application/json')
        let params = new HttpParams().set('userProfileName', userProfileName).set('planYear', planYear)
        let getURL = '../api/isExternalValid/' //+ '/' + userProfileName + '/' + planYear
        //return this.http.get<ValidAgent>(getURL)
        return this.http.get(getURL, { headers: headers, params: params })
    }

    isSingleGroupValid(userProfileName: string): Observable<any> {
        let planYear: string = this.portalGlobal.selectedPlanYear.toString()
        let headers = new HttpHeaders()
        headers = headers.set('Content-Type', 'application/json')
        let params = new HttpParams().set('userProfileName', userProfileName).set('planYear', planYear)
        let getURL = '../api/isSingleGroupValid/' //+ '/' + userProfileName + '/' + planYear
        //return this.http.get<ValidAgent>(getURL)
        return this.http.get(getURL, { headers: headers, params: params })
    }

    generatePDF(enrollmentData: EnrollmentViewModel, insCompanyName: string, planyear: number): Observable<any> {
        var enrllModel = JSON.stringify(this._generatePdfModel.setEnrollmentDataPDF(enrollmentData, insCompanyName))

        var downloadPdfData = this.http.post<any>('../api/enrollmentPdfDownload/' + planyear, enrllModel)
        return downloadPdfData
    }

    printEnrollmentPDF(enrollmentData: EnrollmentViewModel, insCompanyName: string): Observable<any> {
        var enrllModel = JSON.stringify(this._generatePdfModel.setEnrollmentDataPDF(enrollmentData, insCompanyName))
        //this._generatePdfModel.setEnrollmentDataPDF(enrollmentData)
        var downloadPdfData = this.http.post<any>('../api/getEnrollmentHardCopy', enrllModel)
        return downloadPdfData
    }

    getEnrollmentAppDetails(guid: string): Observable<EnrollmentFieldEapp[]> {
        return this.http.get<EnrollmentFieldEapp[]>('../api/enrollment/GetEnrollmentApplication/' + guid)
    }

    //Chnaged current user calls
    getEnrollmentSetting(planYear: string, currentuser: CurrentUser): Observable<EnrollmentSettingModel> {
        return this.http.post<any>('../api/enrollment/GetEnrollmentPage/' + planYear, JSON.stringify(currentuser))
    }

    updateEAppStatus(eappUpdateStatus: EappUpdateStatus): Observable<EappUpdateStatus> {
        return this.http.post<EappUpdateStatus>('../api/enrollment/UpdateElectronicEnrollmentStatus', JSON.stringify(eappUpdateStatus))
    }

    getElectionPeriods(planYear: string, isDataEntryOrExternal: number): Observable<ElectionPeriods[]> {
        return this.http.get<ElectionPeriods[]>('../api/enrollment/GetElectionPeriods/' + planYear + '/' + isDataEntryOrExternal)
    }

    getEappDetails(uniqueLink: string): Observable<EappUpdateStatus[]> {
        return this.http.get<EappUpdateStatus[]>('../api/enrollment/GetEappDetails/' + uniqueLink)
    }

    getEAppHistoryForExport(searchsoadetail: SearchInsertModel): Observable<ExportHistoryModel[]> {
        return this.http.post<ExportHistoryModel[]>('../api/getEAppHistoryForExport', JSON.stringify(searchsoadetail))
    }

    getPWEAppHistoryForExport(searchsoadetail: SearchInsertModel): Observable<ExportHistoryModel[]> {
        return this.http.post<ExportHistoryModel[]>('../api/getPWEAppHistoryForExport', JSON.stringify(searchsoadetail))
    }

    GetPreEnrollmentBeneficiaryDtl(calllogId: number): Observable<PreEnrollmentCallLogDetails> {
        return this.http.get<PreEnrollmentCallLogDetails>('../api/callstart/GetPreEnrollmentBeneficiaryDtl/' + '/' + calllogId)
    }
    getDispositionByPlanYear(planYear: string): Observable<DispositionLookUP[]> {
        return this.http.get<DispositionLookUP[]>('../api/callstart/getdispositionbyplanyear/' + planYear)
    }
    getStcobDetails(orgId: number): Observable<stcobModel[]> {
        return this.http.get<stcobModel[]>('../api/enrollment/GetCagDetailsList/' + orgId)
    }

    getStcobDetailsByState(orgId: number, stateCd: string): Observable<stcobModel[]> {
        return this.http.get<stcobModel[]>('../api/enrollment/GetCagDetailsListByState/' + orgId + '/' + stateCd)
    }

    getGroupPlanList(groupPlanFilterData: GroupPlanFilterData): Observable<stcobModel[]> {
        return this.http.post<stcobModel[]>('../api/enrollment/GetGroupPlans', JSON.stringify(groupPlanFilterData))
    }

    getStcobDetail(orgId: number, planShortName: string, stateCd: string): Observable<stcobModel> {
        return this.http.get<stcobModel>('../api/enrollment/GetCagDetail/' + orgId + '/' + planShortName + '/' + stateCd)
    }

    GetPhoneEnrollmentAcccessCheck(OrgId: number, RoleId: string): Observable<boolean> {
        return this.http.get<boolean>('../api/GetPhoneEnrollmentAcccessCheck/' + OrgId + '/' + RoleId)
    }
    EndEnrollmentCall(preEnrollmentCallLogDetails: PreEnrollmentCallLogDetails): Observable<number> {
        return this.http.post<number>('../api/callstart/EndEnrollmentCall/', JSON.stringify(preEnrollmentCallLogDetails))
    }
    SaveCallErollmentLog(CallLogId: number, EnrollmentStartDate: string, CallDispositionID: number, IsBeneficiary: number): Observable<number> {
        return this.http.get<number>(
            '../api/callstart/SaveCallErollmentLog/' + CallLogId + '/' + EnrollmentStartDate + '/' + CallDispositionID + '/' + IsBeneficiary
        )
    }
    SaveCallLogClientLookup(model: CallLogLookUp): Observable<number> {
        let body = JSON.stringify(model)
        return this.http.post<number>('../api/callstart/SaveCallLogClientLookup', body)
    }
    CheckParentOragnizationId(OrgId: number): Observable<number> {
        return this.http.get<number>('../api/callstart/CheckParentOragnizationId/' + OrgId)
    }

    validateZip(PermanentStateCode: string, PermanentZipCode: string, MailingStateCode: string, MailingZipCode: string): Observable<string[]> {
        return this.http.get<string[]>(
            '../api/enrollment/IsZipValid/' + PermanentStateCode + '/' + PermanentZipCode + '/' + MailingStateCode + '/' + MailingZipCode
        )
    }

    validateZipForAll(
        PermanentStateCode: string,
        PermanentZipCode: string,
        MailingStateCode: string,
        MailingZipCode: string,
        AuthStateCode: string,
        AuthZipCode: string
    ): Observable<string[]> {
        return this.http.get<string[]>(
            '../api/enrollment/IsZipValidForAll/' +
                PermanentStateCode +
                '/' +
                PermanentZipCode +
                '/' +
                MailingStateCode +
                '/' +
                MailingZipCode +
                '/' +
                AuthStateCode +
                '/' +
                AuthZipCode
        )
    }

    validateZipCode(PermanentStateCode: string, PermanentZipCode: string): Observable<string> {
        return this.http.get<string>('../api/enrollment/zipCodeValidation/' + PermanentStateCode + '/' + PermanentZipCode)
    }

    getPreEnrollmentCallLogDetails(): PreEnrollmentCallLogDetails {
        return this._preEnrollmentCallLogDetails
    }

    getOrgAppFeatureSettingValues(orgId: number, featureName: string, settingName: string): Observable<OrgFeatureSettingValue[]> {
        let getUrl = '../api/getFMOSettings/' + orgId + '/' + featureName + '/' + settingName
        return this.http.get<OrgFeatureSettingValue[]>(getUrl)
    }
    setPreEnrollmentCallLogDetails(preEnrollmentCallLogDetails: PreEnrollmentCallLogDetails) {
        this._preEnrollmentCallLogDetails = preEnrollmentCallLogDetails
    }

    getCUIDByUserName(userProfileName: string): Observable<string> {
        let getURL = '../api/getCUIDByUserName' + '/' + userProfileName
        return this.http.get<string>(getURL)
    }

    GetAllIPadHistory(FmoModel: IPadHistory): Observable<IPadHistory[]> {
        return this.http.post<any>('../api/GetIPadHistory', JSON.stringify(FmoModel))
        /* let getURL = '../api/GetIPadHistory/' + FmoModel
        return this.http.get<IPadHistory[]>(getURL) */
    }

    GetAllPWIPadHistory(FmoModel: IPadHistory): Observable<IPadHistory[]> {
        return this.http.post<any>('../api/GetPWIPadHistory', JSON.stringify(FmoModel))
        /* let getURL = '../api/GetIPadHistory/' + FmoModel
        return this.http.get<IPadHistory[]>(getURL) */
    }

    GetAllParentStatesForOrg(InsuranceCoID: number): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetAllParentStatesForOrg/' + InsuranceCoID
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    GetAllIPadHistorySync(FmoModel: IPadHistory): IPadHistory[] {
        var data = JSON.stringify(FmoModel)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/GetIPadHistory', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    GetAllIPadExcel(FmoModel: IPadHistory): Observable<IPadHistory[]> {
        return this.http.post<any>('../api/GetIPadHistoryExcel', JSON.stringify(FmoModel))
    }
    downloadPDFIPad(FmoModel: IPadPDF): Observable<any> {
        var downloadData = this.http.post<any>('../api/getIpadHistoryPDFHardCopy', JSON.stringify(FmoModel))
        console.log('data reteurned from controller' + downloadData)
        return downloadData
    }
    getPDFFileName(confirmationNumber: string, preEnrollmentId: number): Observable<IPadPDF[]> {
        let getURL = '../api/GetIPadPdfFileName/' + confirmationNumber + '/' + preEnrollmentId
        return this.http.get<IPadPDF[]>(getURL)
    }
    SendEmailOnConfirmation(planName: string): Observable<any> {
        return this.http.post<EnrollmentViewModel>(
            '../api/enrollment/SendEmailOnConfirmation/' + planName,
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }
    getEnrollmentHeader(enrollmemtHeader: EnrollmentHeader): Observable<EnrollmentField[]> {
        let body = JSON.stringify(enrollmemtHeader)
        return this.http.post<EnrollmentField[]>('../api/getRetreiveEnrollment/', body)
    }

    getEnrollmentDetail(getEnrollmentRequest: GetEnrollmentRequest): Observable<GetEnrollmentDataResponse> {
        return this.http.post<GetEnrollmentDataResponse>('../api/enrollment/GetEnrollmentFilled', JSON.stringify(getEnrollmentRequest))
    }

    getEnrollmentDetailByEnrollmentID(enrollmentId: number): Observable<GetEnrollmentDataByID> {
        return this.http.get<GetEnrollmentDataByID>('../api/GetEnrollmentDataByEnrID/' + enrollmentId)
    }

    downloadIPadLoginHistoryExcel(): Observable<any> {
        var downloadPdfData = this.http.get<any>('../api/enrollment/DownloadIpadHistoryExcel')
        return downloadPdfData
    }

    getOrgIdByUserName(userProfileName: string): Observable<string> {
        let getURL = '../api/getOrgIdByUserName' + '/' + userProfileName
        return this.http.get<string>(getURL)
    }

    getPhonePage3Data(): Observable<PhonePage3Data> {
        return this.http.get<PhonePage3Data>('../api/enrollment/getPhonePage3Data')
    }
    getEGWPUserProfileName(): Observable<any> {
        return this.http.get<string>('../api/getEGWPUserProfileName')
    }
    getPlanPremium(OrgID: number, PlanYear: string, Planname: string, StateAbbr: string): Observable<string> {
        let getUrl = '../api/getPlanPremium/' + OrgID + '/' + PlanYear + '/' + Planname + '/' + StateAbbr
        return this.http.get<string>(getUrl)
    }

    //getElectionFormData(planyear: string, isDataEntryOrExternal: number): Observable<ElectionModel> {
    //    let getUrl = '../api/getelectionformdata/' + planyear + "/" + isDataEntryOrExternal
    //    return this.http.get<ElectionModel>(getUrl)
    //}
    getElectionFormData(planyear: string, isDataEntryOrExternal: number, currAppDT: string, reportFlag: boolean): Observable<ElectionModel> {
        let getUrl = '../api/getelectionformdata/' + planyear + '/' + isDataEntryOrExternal + '/' + currAppDT + '/' + reportFlag
        return this.http.get<ElectionModel>(getUrl)
    }
    getDisEnrollmentReasonCodes(): Observable<ReasonCode[]> {
        let geturl = '../api/getdisenrollreasoncodes'
        return this.http.get<ReasonCode[]>(geturl)
    }

    getPaperlessSetting(enrollmentChannel: string): Observable<boolean> {
        let getUrl = '../api/getPaperlessSetting/' + enrollmentChannel
        return this.http.get<boolean>(getUrl)
    }

    getEmailsSetting(planYear: number, SelectedPlanyear: number): Observable<boolean> {
        let getUrl = '../api/getEmailsSetting/' + planYear + '/' + SelectedPlanyear
        return this.http.get<boolean>(getUrl)
    }

    generatePDFSearch(planyear: number, enrollmentData: EnrollmentViewModel, insCompanyName: string): Observable<any> {
        var enrllModel = JSON.stringify(this._generatePdfModel.setEnrollmentDataPDFSearch(enrollmentData, insCompanyName))

        //var downloadPdfData = this.http.post<any>('../api/enrollmentPdfDownload', enrllModel)
        var downloadPdfData = this.http.post<any>('../api/enrollmentPdfDownload/' + planyear, enrllModel)

        return downloadPdfData
    }
    getCurrentDate(): Observable<any> {
        let getUrl = '../api/GetcurrentDate'
        return this.http.get<string>(getUrl)
    }

    CheckDuplicateEnrollment(submitEnrollmentData: EnrollmentViewModel): Observable<string[]> {
        return this.http.post<string[]>(
            '../api/enrollment/CheckDuplicateEnrollment',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }
}
